<template>
  <b-container class="mt-4">
    <b-row class="padding-menu">
      <b-col>
        <h1 class="blue">Bienvenido</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="menu-block menu-1">
          <div class="menu-title-block">
            <b-row align-h="center">
              <b-col>
                <div class="menu-title blue slab">Información general</div>
              </b-col>
            </b-row>
          </div>
          <div class="menu-items-block">
            <div class="items-title-container">
              <div class="items-title blue slab">
                <strong>Información general</strong>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <router-link :to="{name: 'VideoPlayer', params: {video: 'intro-procesos'}}" class="items-title">
                  <b-img :src="`${publicPath}angle-right-solid.svg`" class="caret"></b-img> Explicación del proceso
                </router-link>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <router-link :to="{name: 'VideoPlayer', params: {video: 'intro-terminos'}}" class="items-title">
                  <b-img :src="`${publicPath}angle-right-solid.svg`" class="caret"></b-img> Términos importantes
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="menu-block menu-1">
          <div class="menu-title-block">
            <b-row align-h="center">
              <b-col>
                <div class="menu-title blue slab">Conoce tu perfil</div>
              </b-col>
            </b-row>
          </div>
          <div class="menu-items-block">
            <div class="items-title-container">
              <div class="items-title blue slab">
                <strong>Conoce tu perfil</strong>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <router-link :to="{name: 'Pagador'}" class="items-title">
                  <b-img :src="`${publicPath}angle-right-solid.svg`" class="caret"></b-img> Empresa pagadora - Proveedor
                </router-link>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col">
                <router-link :to="{name: 'Cobrador'}" class="items-title">
                  <b-img :src="`${publicPath}angle-right-solid.svg`" class="caret"></b-img> Empresa cobradora - Distribuidor
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
  export default {
    data () {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>
<style>
  .padding-menu {
    padding-top: 3rem;
    padding-bottom: 4rem;
  }  
</style>
